import { all, call, put, select, takeLatest } from 'typed-redux-saga';
import { getApiParams } from 'api';
import { encode } from 'js-base64';
import { isKzUrl } from 'utils';
import { getHost, getPath, getRegionDomain } from 'selectors';
import { pageModelFetchRequest, pageModelFetchSuccess, pageModelFetchFailed } from './slice';
import { ModelJson } from './types';
import { fetchPageModel } from './api';

export function* pageModelRootSaga() {
	return yield* all([takeLatest(pageModelFetchRequest.type, () => getPageModel())]);
}

function formatModelJSON(model: ModelJson) {
	const breadcrumbs = [...model.breadcrumbs];
	breadcrumbs.pop();

	return { ...model, breadcrumbs };
}

function parsePath(path: string) {
	const parts = path.split('/').filter(Boolean);

	if (parts.length <= 2) {
		return {
			hasExtra: false,
			base: path.endsWith('/') ? path : path + '/',
			extra: null,
		};
	}

	const baseParts = parts.slice(0, parts.length - 1);
	const extra = parts[parts.length - 1];

	return {
		hasExtra: true,
		base: '/' + baseParts.join('/') + '/',
		extra,
	};
}

export function* getPageModel() {
	try {
		const pathname: string = yield select(getPath);
		const host = yield* select(getHost);
		const baseRegion: string = yield select(getRegionDomain);

		//доп логика для Казахстана
		const region = isKzUrl(host) ? 'kazakhstan' : baseRegion;
		const { url, config } = yield* getApiParams('/sp/getModel');
		const kzLangUrl = pathname.startsWith('/kz/');

		let modelJson = yield* call(
			fetchPageModel,
			url,
			{
				pathname: kzLangUrl ? pathname.slice(3) : pathname, //дефиниция принимает только lang поэтому отрезаем кк у пути
				region,
				lang: kzLangUrl ? 'kk' : 'ru',
			},
			config
		);
		const { hasExtra, base } = parsePath(pathname);
		if (hasExtra) {
			const { instoreStores } = yield* call(
				fetchPageModel,
				url,
				{
					pathname: base,
					region,
					lang: 'ru',
				},
				config
			);
			modelJson.instoreStores = instoreStores;
		}

		const formattedModel = formatModelJSON(modelJson); //для форматирования хлебных крошек

		// Для хардкода типовых
		if (formattedModel?.rules?.rulesText) {
			formattedModel.rules.rulesText = encode(formattedModel.rules.rulesText);
		}

		// Для хардкода дополнительных текстов на SLP
		if (formattedModel?.service?.categoryText) {
			formattedModel.service.categoryText = encode(formattedModel.service.categoryText);
		}

		yield put(pageModelFetchSuccess({ data: formattedModel }));
	} catch (error) {
		yield console.log(error);
		yield put(
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			pageModelFetchFailed({ error: { code: error?.status || 500, message: error?.message } })
		);
	}
}
